<template>
  <div id="bar-chart" class="echarts">
    <VueApexCharts type="donut" :options="options" :series="series" :height="height">
    </VueApexCharts>
    <!-- <VueApexCharts type="donut" width="380" ></VueApexCharts> -->
    <!-- <h3 v-if="args.graphTitle != null"> {{args.graphTitle}}</h3> -->
  </div>
</template>

<script >
import VueApexCharts from "vue-apexcharts";
import { sync } from "vuex-pathify";
import ui from "@/../../coreui/helpers/ui";
import apexChartsMixin from "@/../../coreui/mixins/apexChartsMixin";

export default {
  props: ["args"],
  mixins: [apexChartsMixin],
  components: {
    VueApexCharts,
  },
  watch: {
    // fullScreen: {
    //   immediate: true,
    //   handler (val) {
    //   var self = this;
    //   let newOptions = Object.assign({}, this.options, {
    //     xaxis: {
    //       labels: {
    //         show: true,
    //       },
    //     },
    //   });
    //   this.options = newOptions;
    //   setTimeout(function () {
    //     if (val) self.height="98%"
    //     else self.height = "100%"
    //   }, 500);
    //   }
    // },
    args: {
      immediate: true,
      deep: true,
      handler(val, old) {
        this.series = val.values[0].data;
        let newOptions = Object.assign({}, this.options, {
          labels:
            val.labels == null || val.labels == undefined ? [] : val.labels, //.map((i) => this.trim(i))
        });
        this.options = newOptions;
        this.height = val.height + 'px'
      },
    },
    dark: {
      immediate: true,
      handler(val, old) {
        if (val == old) { return }
        let newOptions = Object.assign({}, this.options, {
          stroke: {
            width: 4,
            colors: [ui.theme(val).lighterbg],
          },
          legend: {
            offsetX: 0,
            offsetY: 0,
            position: "top",
            formatter: this.legendFormatter, //this.fullScreen ? self.noTrim : self.shortTrim
          },
        });
        this.options = newOptions;
      },
    },
  },
  data() {
    let self = this;
    return {
      height: 60,
      series: [44, 55, 41, 17, 15],
      options: {
        chart: {
          type: "donut",
          toobar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        dataLabels: {
          enabled: true,
        },
        fill: {
          type: "gradient",
        },
        tooltip: {
          fillSeriesColor: false,
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
      },
    };
  },
  computed: {
    dark: sync("misc/dark"),
    fullScreen: sync("misc/fullScreen"),
    cUnit() {
      return this.args.unit == undefined ? "" : " " + this.args.unit;
    },
  },
  methods: {
    shortTrim(val) {
      return val.toString().substring(0, 8);
    },
    noTrim(val) {
      return val;
    },
    trim(v) {
      if (v == null) return "";
      let ll = 12;
      if (v.length <= ll + 3) return v;
      var lx = ll - 3;
      return this.fullScreen ? v : v.substring(0, 8) + "..."; //+ v.slice(-2)
    },
    toolTipFormatter({ series, seriesIndex, dataPointIndex, w }) {
      return (
        '<div class="arrow_box">' +
        w.globals.labels[seriesIndex] +
        "<br/>" +
        +series +
        this.cUnit +
        "</div>"
      );
    },
    legendFormatter(val) {
      // str.substring(0, str.indexOf(' '))
      return this.fullScreen ? val : this.trim(val) //val.substring(0, val.indexOf(" "));
    },
  },
  beforeMount() {},
  mounted() {},
  created() {},
  destroyed() {},
};
</script>

<style >
.arrow_box {
  border: 2px solid;
  padding: 5px;
}
.echarts {
  width: 100%;
  height: 100%;
}
#bar-chart {
}
</style>